"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper650 = exports.Wrapper700 = exports.Wrapper820 = exports.Wrapper800 = exports.Wrapper900 = exports.Wrapper1000 = exports.Wrapper1120 = exports.Wrapper1500 = exports.WrapperCardGrid = exports.Wrapper = void 0;
var react_1 = __importDefault(require("react"));
var WrapperCardGrid_1 = require("./WrapperCardGrid");
Object.defineProperty(exports, "WrapperCardGrid", { enumerable: true, get: function () { return WrapperCardGrid_1.WrapperCardGrid; } });
var styled_1 = require("./styled");
var Wrapper = function (_a) {
    var style = _a.style, children = _a.children, className = _a.className, maxWidth = _a.maxWidth, align = _a.align, left = _a.left;
    align = align || (left ? 'left' : 'center');
    return (react_1.default.createElement(styled_1.StyledWrapper, { maxWidth: maxWidth, align: align, className: className || '', style: style }, children));
};
exports.Wrapper = Wrapper;
var Wrapper1500 = function (props) { return (react_1.default.createElement(exports.Wrapper, __assign({}, props, { maxWidth: 1500 }))); };
exports.Wrapper1500 = Wrapper1500;
var Wrapper1120 = function (props) { return (react_1.default.createElement(exports.Wrapper, __assign({}, props, { maxWidth: 1120 }))); };
exports.Wrapper1120 = Wrapper1120;
var Wrapper1000 = function (props) { return (react_1.default.createElement(exports.Wrapper, __assign({}, props, { maxWidth: 1000 }))); };
exports.Wrapper1000 = Wrapper1000;
var Wrapper900 = function (props) { return (react_1.default.createElement(exports.Wrapper, __assign({}, props, { maxWidth: 900 }))); };
exports.Wrapper900 = Wrapper900;
var Wrapper800 = function (props) { return (react_1.default.createElement(exports.Wrapper, __assign({}, props, { maxWidth: 800 }))); };
exports.Wrapper800 = Wrapper800;
var Wrapper820 = function (props) { return (react_1.default.createElement(exports.Wrapper, __assign({}, props, { maxWidth: 820 }))); };
exports.Wrapper820 = Wrapper820;
var Wrapper700 = function (props) { return (react_1.default.createElement(exports.Wrapper, __assign({}, props, { maxWidth: 700 }))); };
exports.Wrapper700 = Wrapper700;
var Wrapper650 = function (props) { return (react_1.default.createElement(exports.Wrapper, __assign({}, props, { maxWidth: 650 }))); };
exports.Wrapper650 = Wrapper650;
